export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_soccer-academy-43/artifacts/ysijf5ac_stars%20logo.jpg";

/**
 * Brand logo. Variant:
 * - "full"    : badge image + wordmark stack (default)
 * - "badge"   : badge image only (good for tight spaces)
 */
export default function Logo({ variant = "full", size = "md", className = "" }) {
  const sizes = {
    sm: "h-9 w-9",
    md: "h-11 w-11",
    lg: "h-14 w-14",
  };

  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <span
        className={`relative ${sizes[size] || sizes.md} rounded-md overflow-hidden ring-1 ring-white/10 bg-white/5 flex-shrink-0`}
      >
        <img
          src={LOGO_URL}
          alt="Stars of Mpumalanga"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
      </span>
      {variant === "full" && (
        <span className="font-heading uppercase leading-none tracking-tight">
          <span className="block text-red-600 text-lg font-bold">Stars</span>
          <span className="block text-white text-[10px] tracking-widest mt-1">
            of Mpumalanga
          </span>
        </span>
      )}
    </span>
  );
}
